import { BrowseSubjectPagesSlugs } from "@/subjects/subjects.constants";

export const getLockedContentInfo = (slug: string) => {
  switch (slug) {
    case BrowseSubjectPagesSlugs.ELA:
      return {
        subscription: "Newsela ELA",
        href: "/about/products/ela/",
        description:
          "Drive outcomes with content-rich literacy instruction. Includes novel studies, skill-building activities, and more.",
      };
    case BrowseSubjectPagesSlugs.SCIENCE:
      return {
        subscription: "Newsela Science",
        href: "/about/products/science/",
        description:
          "Get students reading, writing, and thinking like scientists. Includes explainers, data sets, activities and more.",
      };
    case BrowseSubjectPagesSlugs.SOCIAL_STUDIES:
      return {
        subscription: "Newsela Social Studies",
        href: "/about/products/social-studies/",
        description:
          "Relevant and responsive materials, like primary sources, videos, and flexible activities to prepare the next generation of citizens.",
      };
    default:
      return {
        subscription: "",
        href: "",
        description: "",
      };
  }
};
